import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const CookieConsent: React.FC = () => {
  const [showConsent, setShowConsent] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    // Check if user has already given consent
    const hasConsent = localStorage.getItem("cookieConsent");
    if (!hasConsent) {
      setShowConsent(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("cookieConsent", "all");
    setShowConsent(false);
    // Enable analytics cookies here
  };

  const acceptNecessary = () => {
    localStorage.setItem("cookieConsent", "necessary");
    setShowConsent(false);
    // Only enable necessary cookies
    console.log("Only necessary cookies accepted");
  };

  // Remove the option to close without making a choice
  // Users must either accept necessary cookies or all cookies

  const openDatenschutz = () => {
    window.open("/datenschutz", "_blank");
  };

  if (!showConsent) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center p-4 z-50">
      <div className="bg-gray-900 text-white p-4 sm:p-6 shadow-2xl rounded-xl border border-gray-700 w-full max-w-2xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          {/* Content */}
          <div className="flex-1">
            <p className="text-sm leading-relaxed">
              {t("cookieConsent.message")}{" "}
              <button
                onClick={openDatenschutz}
                className="text-brand-red-text hover:text-[#B8001A] underline transition-colors cursor-pointer"
              >
                {t("cookieConsent.learnMore")}
              </button>
            </p>
            <p className="text-xs text-gray-400 mt-2">
              ⚠️ {t("cookieConsent.required")}
            </p>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
            <button
              onClick={acceptNecessary}
              className="px-6 py-3 bg-gray-700 hover:bg-gray-600 text-white text-sm font-medium rounded-lg transition-all duration-200 cursor-pointer hover:shadow-lg"
            >
              {t("cookieConsent.necessaryOnly")}
            </button>
            <button
              onClick={acceptAll}
              className="px-6 py-3 bg-[#D8001D] hover:bg-[#B8001A] text-white text-sm font-medium rounded-lg transition-all duration-200 cursor-pointer hover:shadow-lg"
            >
              {t("cookieConsent.acceptAll")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent; 